import React from "react";
import { Form } from "react-bootstrap";
import { FormikProps } from "formik";
import { SimulatorTextField } from "../fields/SimulatorTextField";
import { FormValues } from "../types";

const FormSwitch = (Form as any).Switch;

interface GDSectionProps {
  formik: FormikProps<FormValues>;
  buttonSelected: string;
  resetSimultaneidade: (e: any) => void;
  resetAbateICMS: (e: any) => void;
}

export const GDSection = ({
  formik,
  buttonSelected,
  resetSimultaneidade,
  resetAbateICMS,
}: GDSectionProps) => (
  <>
    <div>
      <span className="simulacao-form-header">
        Dados da usina de geração distribuída
      </span>
      <hr />
    </div>

    <div className="formLine">
      <Form.Group
        controlId="simulationLocal"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
          display: "flex",
          gap: "32px",
        }}
      >
        <Form.Label className="simulacao-form-title">
          Local de Instalação - É usina local?
        </Form.Label>
        <FormSwitch
          type="switch"
          name="local"
          label=""
          value={formik.values.local}
          onBlur={formik.handleBlur}
          onChange={(e: any) => resetSimultaneidade(e)}
          checked={formik.values.local}
        />
      </Form.Group>

      <Form.Group
        controlId="abateICMS"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
          display: "flex",
          gap: "32px",
        }}
      >
        <Form.Label className="simulacao-form-title">
          A energia injetada compensa o ICMS?
        </Form.Label>
        <FormSwitch
          type="switch"
          name="abateICMS"
          label=""
          value={formik.values.abateICMS}
          onBlur={formik.handleBlur}
          onChange={(e: any) => resetAbateICMS(e)}
          checked={formik.values.abateICMS}
        />
      </Form.Group>
    </div>

    <div className="formLine">
      <SimulatorTextField
        formik={formik}
        name="geracao"
        controlId="simulationCNPJ"
        label={
          <>
            Energia Injetada <span>*</span>
          </>
        }
        placeholder="Em kWh"
        unit="kWh"
        required={buttonSelected !== "ML"}
      />

      <SimulatorTextField
        formik={formik}
        name="demandaUsina"
        controlId="simulationCNPJ"
        label={
          <>
            Demanda da usina <span>*</span>
          </>
        }
        placeholder="Em kW"
        unit="kW"
        required={buttonSelected !== "ML"}
      />

      <SimulatorTextField
        formik={formik}
        name="potenciaUsina"
        controlId="simulationCNPJ"
        label={
          <>
            Potência da Usina <span>*</span>
          </>
        }
        placeholder="Em kWp"
        unit="kWp"
        required={buttonSelected !== "ML"}
      />
    </div>
  </>
);
